import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getUserInviteLink } from '../../../api';

export const securityInvitationsLinkGetAsyncSlice = createGetAsyncSlice({
	name: 'SecurityInvitationsLink',
	receive: true,
	request: true,
	requestHandler: getUserInviteLink
});
